import { jsx as _jsx } from "react/jsx-runtime";
import { CnButton, CnIcon, CnMenuButtonItem, Dropdown, Menu, } from '@alife/cn-ui';
import { hottagPrefix } from '../const';
import { reportHottag } from '$src/utils';
function QuickFieldButton({ onChange, quickSearchFields = [], searchTags = [], disabled = false, quickSearchButtonIcon, }) {
    const trigger = (_jsx(CnButton, { type: 'normal', size: 'small', onClick: () => {
            reportHottag({
                tag: `${hottagPrefix}.openFilter`,
                name: '点击快速筛选',
            });
        }, className: 'search-quick-field-button', disabled: disabled, children: _jsx(CnIcon, { type: quickSearchButtonIcon || 'filter' }) }));
    return Array.isArray(quickSearchFields) && quickSearchFields.length > 0 ? (_jsx(Dropdown, { trigger: trigger, triggerType: ['click'], children: _jsx(Menu, { children: quickSearchFields.map((field) => {
                const { name, key, type, values, analyzeType } = field;
                const isSearchTag = searchTags.some((tag) => tag.entityKey === key);
                return (_jsx(CnMenuButtonItem, { "data-hottag": `${hottagPrefix}.quickField.click`, "data-hottag-ext-params": JSON.stringify({
                        sampling: 1,
                    }), onClick: () => {
                        onChange([
                            ...searchTags,
                            {
                                entityKey: key,
                                values: values || [],
                                name,
                                entityType: type,
                                analyzeType,
                            },
                        ]);
                    }, disabled: isSearchTag, children: name }, key));
            }) }) })) : null;
}
QuickFieldButton.displayName = 'OneSearch.QuickFieldButton';
export default QuickFieldButton;
